"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactstrap = require("reactstrap");
var _helpers = require("../helpers");
var _reactRedux = require("react-redux");
var _redux = require("redux");
var _icon = _interopRequireDefault(require("../../fonts/icon"));
var _Forms = require("./Forms");
var _v = _interopRequireDefault(require("uuid/v1"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const mapStateToProps = (state, props) => {
  return {
    [props.entity.plural]: state[props.entity.plural]
  };
};
const mapDispatchToProps = (dispatch, props) => {
  const {
    actions
  } = props;
  return {
    jump: (0, _redux.bindActionCreators)(actions.jump, dispatch)
  };
};
const stringOps = [{
  displayName: 'contains',
  operator: 'Contains'
}, {
  displayName: 'does not contain',
  operator: 'NotContains'
}, {
  displayName: 'equals',
  operator: 'Equals'
}, {
  displayName: 'starts with',
  operator: 'StartsWith'
}, {
  displayName: 'ends with',
  operator: 'EndsWith'
}];
const numOps = [{
  displayName: 'smaller than',
  operator: '<'
}, {
  displayName: 'smaller than or equal to',
  operator: '<='
}, {
  displayName: 'equal to',
  operator: '='
}, {
  displayName: 'not equal to',
  operator: '!='
}, {
  displayName: 'greater than or equal to',
  operator: '>='
}, {
  displayName: 'greater than',
  operator: '>'
}];
const dateOps = [{
  displayName: 'earlier than',
  operator: '<'
}, {
  displayName: 'earlier than or on',
  operator: '<='
}, {
  displayName: 'on',
  operator: '='
}, {
  displayName: 'later than or on',
  operator: '>='
}, {
  displayName: 'later than',
  operator: '>'
}];
const boolOps = [{
  displayName: 'Yes',
  operator: '= true'
}, {
  displayName: 'No',
  operator: '!= true'
}];
const enumOps = [{
  displayName: 'is',
  operator: '='
}, {
  displayName: 'is not',
  operator: '!='
}];
let enumValues = [];
const CreateDropdown = ({
  state,
  values,
  value,
  onChange
}) => {
  return /*#__PURE__*/_react.default.createElement(_reactstrap.UncontrolledDropdown, {
    className: "d-inline-block"
  }, /*#__PURE__*/_react.default.createElement(_reactstrap.DropdownToggle, {
    className: "nav-link",
    caret: true,
    color: "link"
  }, value === null || value === "" ? 'Select' : value), /*#__PURE__*/_react.default.createElement(_reactstrap.DropdownMenu, null, values.map((val, index) => {
    return /*#__PURE__*/_react.default.createElement(_reactstrap.DropdownItem, {
      key: index,
      onClick: () => onChange(val),
      active: value !== null && val.displayName === value.displayName
    }, val.displayName);
  })));
};
class ListFilter extends _react.default.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "handleChange", (value, property, operator = '=') => {
      this.props.onFilter({
        property,
        operator,
        value
      });
    });
    _defineProperty(this, "onFilterTypeSelect", val => {
      const {
        [this.props.entity.plural]: store
      } = this.props;
      new Promise(resolve => {
        this.setState({
          filterOp: null,
          filterOpLabel: null,
          filterProp: val.key,
          filterPropLabel: val.displayName,
          operatorsArray: [],
          filterValue: '',
          filterValueLabel: ''
        });
        resolve();
      }).then(() => {
        switch (val.type) {
          case 'String':
          case 'Email':
            this.setState({
              filterType: 'String',
              operatorsArray: stringOps
            });
            break;
          case 'Number':
            this.setState({
              filterType: 'Number',
              operatorsArray: numOps
            });
            break;
          case 'Date':
            this.setState({
              filterType: 'Date',
              operatorsArray: dateOps
            });
            break;
          case 'Bool':
            this.setState({
              filterType: 'Bool',
              operatorsArray: boolOps
            });
            break;
          case 'Enum':
            this.setState({
              filterType: 'Enum',
              operatorsArray: enumOps
            });
            enumValues = [];
            for (let i in store.list.schema) {
              if (store.list.schema[i].type === "Enum" && store.list.schema[i].displayName === this.state.filterProp) {
                for (let [key, value] of Object.entries(store.list.schema[i].options)) {
                  let item = {
                    operator: key,
                    displayName: value
                  };
                  enumValues.push(item);
                }
                break;
              }
            }
        }
      }).catch(err => {
        console.dir(err);
      });
    });
    _defineProperty(this, "onFilterOpSelect", val => {
      this.setState({
        filterOp: val.operator
      });
      this.setState({
        filterOpLabel: val.displayName
      });
    });
    _defineProperty(this, "onFilterEnumSelect", val => {
      this.setState({
        filterValue: val.operator
      });
      this.setState({
        filterValueLabel: val.displayName
      });
    });
    _defineProperty(this, "onFilterValue", e => {
      {
        e.preventDefault && e.preventDefault();
      }
      if (e.target) {
        this.setState({
          filterValue: e.target.value
        });
        this.setState({
          filterValueLabel: e.target.value
        });
      }
    });
    _defineProperty(this, "onFilterDate", e => {
      {
        e.preventDefault && e.preventDefault();
      }
      let modDate = (0, _helpers.getEndOfDay)(e);
      let displayDate = modDate.format('DD.MM.YYYY');
      let endDate = modDate.toISOString();
      this.setState({
        filterValue: e,
        filterValue2: endDate,
        filterValueLabel: displayDate
      });
    });
    _defineProperty(this, "onSubmitFilter", e => {
      {
        e.preventDefault && e.preventDefault();
      }
      const uuid = (0, _v.default)();
      const {
        onFilter,
        onJump,
        onDeleteAllFilters
      } = this.props;
      let filterBy = {
        id: uuid,
        type: this.state.filterType,
        property: this.state.filterProp,
        propLabel: this.state.filterPropLabel,
        operator: this.state.filterOp,
        opLabel: this.state.filterOpLabel,
        value: this.state.filterValue.toLowerCase(),
        value2: this.state.filterValue2,
        valueLabel: this.state.filterValueLabel
      };
      if (this.state.filterType === "Date") {
        filterBy.value = `DateTimeOffset.Parse("${filterBy.value}")`;
        filterBy.value2 = `DateTimeOffset.Parse("${filterBy.value2}")`;
      }
      this.setState({
        filterProp: null,
        filterPropLabel: null,
        filterType: null,
        filterOp: null,
        filterOpLabel: null,
        filterValue: '',
        filterValue2: '',
        filterValueLabel: ''
      });
      enumValues = [];
      onDeleteAllFilters();
      onFilter(filterBy);
      onJump([1]);
    });
    _defineProperty(this, "onDeleteFilter", (filter, e) => {
      const {
        onDeleteFilter
      } = this.props;
      onDeleteFilter(filter);
    });
    _defineProperty(this, "onDeleteAllFilters", () => {
      const {
        onDeleteAllFilters
      } = this.props;
      onDeleteAllFilters();
      const input = document.getElementById("input");
      input.value = '';
    });
    _defineProperty(this, "render", () => {
      const {
        // selection,
        // values,
        // fetching,
        // fetched,
        // onClick,
        // onSelect,
        // onSelectAll,
        // onDelete,
        // onErrorRead,
        // onChange,
        // onAdd,
        // onDrop,
        // create,
        // actions,
        // onSort,
        // onFilter,
        // groups,
        generalSettings,
        [this.props.entity.plural]: entity,
        ...rest
      } = this.props;
      if (generalSettings) {
        if (!generalSettings.tableFilterEnabled) {
          return /*#__PURE__*/_react.default.createElement("span", null);
        }
      }
      let columns = entity.list.schema;
      let colsArray = [];
      let filterableCols = [];
      let filterableArray = [];
      colsArray = Object.entries(columns).map(([key, value]) => ({
        key,
        value
      }));
      for (let i in colsArray) {
        if (colsArray[i].value.filterable && colsArray[i].value.filterable === true) {
          filterableCols.push(colsArray[i]);
        }
      }
      if (filterableCols.length === 0) return /*#__PURE__*/_react.default.createElement("span", null);
      for (let i in filterableCols) {
        filterableArray.push(filterableCols[i].value);
        filterableArray[i].key = filterableCols[i].key;
      }
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "row ml-2 mr-2"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "row w-100 ml-1 mr-1",
        style: {
          height: "4rem",
          overflow: "visible",
          display: 'flex',
          justifyContent: 'space-between'
        }
      }, /*#__PURE__*/_react.default.createElement(_reactstrap.Form, {
        inline: true,
        onSubmit: e => this.onSubmitFilter(e)
      }, /*#__PURE__*/_react.default.createElement(_reactstrap.FormGroup, {
        className: "align-self-start mr-3"
      }, /*#__PURE__*/_react.default.createElement(_reactstrap.Input, {
        type: "text",
        name: "filterValue"
        // value={this.state.filterValue}
        ,
        onChange: e => this.onFilterValue(e),
        autoFocus: true,
        placeholder: "Search",
        id: "input",
        required: true,
        style: {
          borderRight: '0px',
          borderTopRightRadius: '0px',
          borderBottomRightRadius: '0px'
        }
      }), /*#__PURE__*/_react.default.createElement("button", {
        onClick: e => this.onSubmitFilter(e),
        type: "button",
        style: {
          outline: 'none',
          background: 'transparent',
          border: '1px solid #ced4da',
          borderLeft: '0px',
          padding: '.31rem .75rem',
          borderTopRightRadius: '.25rem',
          borderBottomRightRadius: '.25rem'
        }
      }, /*#__PURE__*/_react.default.createElement(_icon.default, {
        icon: "search",
        size: 23
      })), entity.list.filters.length !== 0 ? /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: "close ml-3 d-flex align-items-center",
        "aria-label": "Close",
        onClick: this.onDeleteAllFilters
      }, /*#__PURE__*/_react.default.createElement("span", {
        "aria-hidden": "true"
      }, "\xD7"), /*#__PURE__*/_react.default.createElement("span", {
        style: {
          fontSize: '16px',
          fontWeight: '300',
          marginTop: '4px',
          marginLeft: '.5em'
        }
      }, "Cancel")) : null))));
    });
    this.state = {
      filterProp: null,
      filterPropLabel: null,
      filterType: null,
      filterOp: null,
      filterOpLabel: null,
      filterValue: '',
      filterValue2: '',
      filterValueLabel: '',
      operatorsArray: []
    };
    const {
      [props.entity.plural]: _store
    } = props;
    this.fields = (0, _helpers.objectToArray)(_store.schema).filter(field => field.filter && field.filter.enabled);
  }
}
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ListFilter);
module.exports = exports.default;